import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from "@mui/material/Fade";

import { LOADING } from "./Table/TimelineTable";

const TableLoadingIndicator = (props) => {

    let open= [LOADING.NORMAL, LOADING.AT_START].includes(props.loadingState)
    let text= [LOADING.AT_START, LOADING.AT_END].includes(props.loadingState)
        ? 'Loading more'
        : 'Loading';
    let position=(props.loadingState === LOADING.AT_START)
        ? 'top'
        : (props.loadingState === LOADING.AT_END)
            ? 'bottom'
            : '';

    //// Bit of a hack to deal with displayig loading messages when the timeline table
    //// is displaying records in descending date order.
    //if (!props.reverseLoadingDirection) {
    //    open= [LOADING.NORMAL, LOADING.AT_END].includes(props.loadingState)
    //    text= [LOADING.AT_START, LOADING.AT_END].includes(props.loadingState)
    //        ? 'Loading more'
    //        : 'Loading';
    //    position=(props.loadingState === LOADING.AT_END)
    //        ? 'top'
    //        : (props.loadingState === LOADING.AT_START)
    //            ? 'bottom'
    //            : '';
    //}


    const getClassNames = () => {
        return position ?? '';
    }

    if (!open) {
        return null;
    }

    return (
        <Fade in={open} timeout={500}>
            <div className={`table-loading-indicator ${getClassNames()}`}>
                <div className="loading-info">
                    <span className="message">
                        {text}
                    </span>
                    <CircularProgress/>
                </div>
            </div>
        </Fade>
    )
}

TableLoadingIndicator.propTypes = {
    loadingState: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    reverseLoadingDirection: PropTypes.bool,
}

TableLoadingIndicator.defaultProps = {
    reverseLoadingDirection: false
}

export default TableLoadingIndicator;
